import { useContext } from "react"
import { CadastroAplicativoContext } from "./CadastroAplicativoContext"

export function useCadastroAplicativoContext() {
    return useContext(CadastroAplicativoContext)
}
